import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Modal, Row } from 'antd';
import usecustomStyles from '../../Common/customStyles';
import Widget from './Widget';
import RecentOrder from './RecentOrder';
import LiveAds from './LiveAds/LiveAds';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getDashboard } from '../../slices/dashboard/thunk';
import { getWorks } from '../../slices/works/thunk';
import { getCatalogue } from '../../slices/catalog/thunk';
import NoResults from '../Components/NoResults/NoResults';
import { getNotification } from '../../slices/notification/thunk';
import { getVerifiedStatus } from '../../Services/LocalStorageService';
import RejectedUi from './RejectedUi/RejectedUi';
import { VerificationStatusClassUpdate } from '../../Services/AdsStatusService';
import DateService from '../../Services/DateService';
import Warning from '../../Common/Warning/Warning';

const customStyles = usecustomStyles();
const Dashboard = () => {
  const [status , setStatus] = useState('');
  const navigate = useNavigate();

  document.title = "Dashboard" 
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const [modal , setModal] = useState(true);
  const [verified , setVerified] = useState(false);
  const [catalogDataPresent , setCatalogDataPresent] = useState(true);
  const [worksDataPresent , setWorksDataPresent] = useState(true);
  const dashboardData = useSelector((state)=>state.Dashboard);
  const worksData = useSelector((state)=>state.Works);
  const catalogData = useSelector((state)=>state.Catalog);
  const businessInfo = useSelector((state)=>state.BusinessInfoReducer)
  const [warning , setWarning] = useState({
    title: '',
    content: '',
    verifiedStatus:'' ,
    warningStatus: '',
    statusClass: '',
    createdAt: '',
  })
  const [verificationStatusClass , setVerificationStatusClass] = useState();

  const getStatus = ((data)=>{
    setStatus(data)
  })
  useEffect(()=>{
    dispatch(getDashboard());
    dispatch(getWorks({limit:10,page:1}));
    dispatch(getCatalogue({limit:10,page:1}))

  },[dispatch])


 
  let isProfileApprovedByAdmin
  useEffect(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  useEffect(()=>{
    if(dashboardData){
      let warning = dashboardData?.data?.warning;
       isProfileApprovedByAdmin = dashboardData?.data?.isProfileApprovedByAdmin;
      let adminStatus = dashboardData?.adminVerificationStatus;
      let statusClass = VerificationStatusClassUpdate( dashboardData?.data?.isProfileApprovedByAdmin);

      const createdAt = dashboardData?.data?.created_at;

      const isCreatedWithin24Hours = (createdAt) => {
        // Check if createdAt is a valid date string
        if (!createdAt) return false; // Return false if createdAt is undefined or null
      
        const createdDate = new Date(createdAt); // Convert createdAt to Date object
        const currentDate = new Date(); // Get the current date and time
      
        // Calculate the difference in milliseconds
        const differenceInMillis = currentDate - createdDate;
      
        // Convert milliseconds to hours
        const differenceInHours = differenceInMillis / (1000 * 60 * 60);
      
        return differenceInHours < 24; // Return true if less than 24 hours
      };
      
      
      
      if(isProfileApprovedByAdmin){
        setWarning(
          {
            title: warning?.title,
            content: warning?.description,
            verifiedStatus: adminStatus,
            warningStatus: statusClass,
            rawStatus: isProfileApprovedByAdmin,
            createdAt : createdAt,
            successWarningStatus: isCreatedWithin24Hours(createdAt)
          }
        )
      }
      if(dashboardData?.data?.profile_verified_admin === false){
        // temporary
        setModal(false)
        localStorage.setItem('isVerified', JSON.stringify(false));
      }else{
        localStorage.setItem('isVerified', JSON.stringify(true));
        setModal(false)
      }  
    }

  },[dashboardData , dispatch , catalogData , worksData])


  const location = useLocation();

  

  useEffect(()=>{
    if(catalogData?.data?.length > 0){
      setCatalogDataPresent(false);
    }
  },[catalogData])

  useEffect(()=>{
    if(worksData?.data.length > 0){
      setWorksDataPresent(false);
    }
  },[worksData])

  // useEffect(()=>{
  //   let profileCompletion = businessInfo?.businessInfo?.profile_completion;
  //   if(businessInfo?.businessInfo?.profile_completion){
  //     if(profileCompletion !== 6){
  //       navigate('/login')
  //     }
  //   }
  // },[businessInfo])

// useEffect(()=>{
//   if(warning?.verifiedStatus){
    
//   }
// },[warning])
  

  return (
    <>
      {/* <Breadcrumb mainTitle="Lizant" pageTitle="Dashboard" /> */}
    
      <div className='dashboard_cnt block'>
      <Warning/>

      <Col xs={24} xxl={24}>
          <div>
          <Row gutter={[24, 24]} style={{ marginTop: customStyles.margin }} className='dashboard_liveAds'>
              <LiveAds data={dashboardData?.data?.ads} getStatusData={getStatus}/>
            </Row>
          <div style={{ marginTop: customStyles.margin }}>
            <h4 className="text_md mb">Summary</h4>
              <Row gutter={[24, 24]}  className='dashboard_widget'>
                <Widget data={dashboardData.data.counts}/>
              </Row>
          </div>
            <Row gutter={[16, 16]} className='dashboard_recentOrder'>
              <RecentOrder  />
            </Row>
          </div>
      </Col>
    </div>
    {
  worksDataPresent && (
    <Col className='bg_white' style={{ marginTop: customStyles.margin }}>
    <NoResults
      type={'works'}
      title={'Upload Your Works'}
      description={'Upload your top works to engage more customers. These images will be highlighted on your business page for all to see!'}
    >
      <Button
        className="wide mb"
        type='primary'
        onClick={() => {
          navigate('/works'); 
        }}
      >
      Add Works
      </Button>
    </NoResults>
  </Col>
  )
}


{catalogDataPresent && (
 (
    <Col className='bg_white' style={{ marginTop: customStyles.margin }}>
       <NoResults
          type={'catalog'}
          title={'Create Your Catalogue'}
          description={'Showcase your catalogue item to customers by uploading your latest catalogues. These will be visible on your business page for all to see!'}>
        <Button
          className="wide mb"
          type='primary'
          onClick={() => {
            navigate('/catalogue');
          }}
        >
          Create Catalogue
        </Button>
      </NoResults>
    </Col>
  )
)}

    <div className="not_verified">
    {/* <Modal
          className='sm_modal text-center' style={{lineHeight: '1.5'}}
          open={modal}
          footer={null}
          closable={false}
        >
       <div className='text_cnt'>
          <p><span className='text_red semibold'>Your account</span> is awaiting verification from our Admin. We will update you once the review is finished and your account is active.</p>
       </div>
       <Button type='primary' onClick={()=>{
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('userDetails')
        window.location.href = '/login'
       }}>Log Out</Button>
        </Modal> */}
    </div>
    </>
  )
}

export default Dashboard;
